
export enum WineType {
  RED = 'Rosso',
  WHITE = 'Bianco',
  ROSE = 'Rosato',
  SPARKLING = 'Bollicina',
  DESSERT = 'Passito/Dessert',
  SPIRITS = 'Liquore/Distillato',
  OTHER = 'Altro'
}

export interface GroundingSource {
  title: string;
  uri: string;
}

export interface ConsumedWine {
  id: string;
  name: string;
  producer: string;
  vintage: string;
  type: WineType;
  consumedAt: number;
  imageUrl: string;
}

export interface Wine {
  id: string;
  name: string;
  producer: string;
  vintage: string;
  type: WineType;
  price: number;
  description: string;
  grapes: string;
  foodPairings: string[];
  drinkingWindow: string;
  imageUrls: string[]; // [0] professionale, [1] originale
  quantity: number;
  addedAt: number;
  review?: string; // Note di degustazione (post-bevuta)
  notes?: string;  // Note varie (prezzo acquisto, rivendita, posizione)
  sources?: GroundingSource[];
}

export interface CellarStats {
  totalBottles: number;
  totalValue: number;
  byType: Record<string, number>;
}

declare global {
  interface Window {
    gapi: any;
    google: any;
  }
}
